import React from 'react'
import { Container, Description, Image, Title } from './styles'

function Item({ item }) {
	const { image, title, description, titleColor, textColor } = item;
	return (
		<Container>
			<Image>
				<img
					src={`https://${image.fields.file.url}`}
					alt={image.fields.title}
				/>
			</Image>
			<Title color={titleColor}>{title}</Title>
			<Description color={textColor}>{description}</Description>
		</Container>
	)
}

export default Item;
